import * as types from './constants';

// Activate Code Bulk
export const activateCodeBulkRequest = data => (
  { type: types.ACTIVATE_CODE_BULK_REQUEST, payload: data }
);

export const activateCodeBulkDone = data => (
  { type: types.ACTIVATE_CODE_BULK_DONE, payload: data }
);

export const activateCodeBulkFailed = errors => (
  { type: types.ACTIVATE_CODE_BULK_FAILED, payload: errors }
);